<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.main-content {
  padding-left: 24px;
  padding-right: 24px;
}

i.icon {
  display: inline-block;
}

.img_container {
  line-height: 0;
  img {
    width: 100%;
  }
}

.white {
  color: #ffffff!important;
}

.icon_img {
  img {
    width: 18px;
  }
}

.top_banner {
  background-size: cover;
  background-repeat: no-repeat;
  .banner_container {
    height: 160px;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    padding: 0 24px;
    text-align: center;

    .headline {
      font-size: 18px;
    }

    .text {
      font-size: 12px;
    }
  }
}

.full_width {
  margin-left: -24px;
  margin-right: -24px;

  .section-title, .section-info {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.section {
  padding-bottom: 30px;
}

.section-title {
  font-size: 20px;
  color: #222327;
  background: #ffffff;
}

.section-info {
  font-size: 14px;
  color: #54585a;
  background: #ffffff;
}

.section-content {
  margin-top: 20px;
}

button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 6px 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 0;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-blue {
  color: #fff;
  background-color: #009ee3;
  border-color: #009ee3;
}
// solution ------ start ------
.solutions {
  position: relative;
  padding: 0 0 0rem 0;
  background-color: #d4d5d6; }

.solutions__imagewrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 37.5%;
  overflow: hidden;
  background-color: #fff; }

.solutions__image {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%; }
.solutions__image > svg, .solutions__image > img {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%; }
.solutions__image .solutions__foreground {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  -webkit-transform-origin: 50% 90%;
  -ms-transform-origin: 50% 90%;
  transform-origin: 50% 90%;
  -webkit-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.6s;
  transition-duration: 0.6s;
  -webkit-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transition-delay: 0s;
  transition-delay: 0s; }
.solutions__image .solutions__foreground > svg, .solutions__image .solutions__foreground > img {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  -webkit-transition-property: margin-left;
  transition-property: margin-left;
  -webkit-transition-duration: 0.6s;
  transition-duration: 0.6s;
  -webkit-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transition-delay: 0s;
  transition-delay: 0s; }

.solutions__stage a.icon {
  display: block;
  position: absolute;
  top: 50%; }

.solutions__stage a.icon:before {
  position: absolute;
  top: 0;
  color: #009ee3;
  text-shadow: rgba(255, 255, 255, 0.8) 0px 0px 20px; }

.solutions__stage a.icon:hover:before {
  color: #15B2F6; }

.solutions__stage a.icon_prev {
  left: 0px; }

.solutions__stage a.icon_prev:before {
  left: 4px; }

.solutions__stage a.icon_next {
  right: 0px; }

.solutions__stage a.icon_next:before {
  right: 4px; }

.solutions__stage .solutions__imagewrapper a.icon {
  width: 25px;
  height: 30px;
  margin-top: -15px; }

.solutions__stage .solutions__imagewrapper a.icon:before {
  font-size: 1.25rem; }

.solutions__stage > a.icon {
  width: 40px;
  height: 50px;
  margin-top: -25px;
  display: none; }

.solutions__stage > a.icon:before {
  font-size: 2.25rem; }

.solutions__stage.step-1 .solutions__content.content-1 {
  display: block; }

.solutions__stage.step-2 .solutions__foreground {
  -webkit-transform: scale(2);
  -ms-transform: scale(2);
  transform: scale(2); }

.solutions__stage.step-2 svg.img-main, .solutions__stage.step-2 img.img-main {
  margin-left: 40%; }

.solutions__stage.step-2 .solutions__content.content-2 {
  display: block; }

.solutions__stage.step-3 .solutions__foreground {
  -webkit-transform: scale(2);
  -ms-transform: scale(2);
  transform: scale(2); }

.solutions__stage.step-3 svg.img-main, .solutions__stage.step-3 img.img-main {
  margin-left: 6%; }

.solutions__stage.step-3 svg.img-lines {
  margin-left: -6%; }

.solutions__stage.step-3 .solutions__content.content-3 {
  display: block; }

.solutions__stage.step-4 .solutions__foreground {
  -webkit-transform: scale(2);
  -ms-transform: scale(2);
  transform: scale(2); }

.solutions__stage.step-4 svg.img-main, .solutions__stage.step-4 img.img-main {
  margin-left: -16%; }

.solutions__stage.step-4 svg.img-lines {
  margin-left: -12%; }

.solutions__stage.step-4 .solutions__content.content-4 {
  display: block; }

.solutions__stage.step-5 .solutions__foreground {
  -webkit-transform: scale(2);
  -ms-transform: scale(2);
  transform: scale(2); }

.solutions__stage.step-5 svg.img-main, .solutions__stage.step-5 img.img-main {
  margin-left: -32%; }

.solutions__stage.step-5 svg.img-lines {
  margin-left: -18%; }

.solutions__stage.step-5 .solutions__content.content-5 {
  display: block; }

.solutions__stage.step-6 .solutions__foreground {
  -webkit-transform: scale(1.4);
  -ms-transform: scale(1.4);
  transform: scale(1.4); }

.solutions__stage.step-6 svg.img-main, .solutions__stage.step-6 img.img-main {
  margin-left: 10%; }

.solutions__stage.step-6 .solutions__content.content-6 {
  display: block; }

.solutions__overlay {
  margin-top: -1px;
  width: 100%;
  background-color: #d4d5d6; }

.solutions__content {
  padding: 1.25rem 0rem 0.5rem 0rem;
  display: none;
  min-height: 360px; }
.solutions__content p {
  color: #222327; }
.solutions__content .btn {
  margin: 0 0.75rem 0.5rem 0;
  font-size: 0.875rem;
  letter-spacing: 0.075rem; }

.solutions__controls {
  background-color: #d4d5d6;
  padding: 0rem 0 1.75rem 0; }

.solutions__btn-step {
  position: relative;
  display: block;
  float: left;
  width: 16.666%;
  height: 40px;
  background-color: rgba(255, 255, 255, 0); }
.solutions__btn-step span {
  display: none;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.875rem;
  /*letter-spacing: 0.075rem;*/
  color: #0d3b6d;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transition-delay: 0s;
  transition-delay: 0s; }

.solutions__btn-step:before {
  display: block;
  content: "";
  width: 100%;
  height: 2px;
  position: absolute;
  left: 0;
  top: 20px;
  background-color: #0d3b6d; }

.solutions__btn-step:first-child:before {
  width: 50%;
  left: 50%; }

.solutions__btn-step:last-child:before {
  width: 50%; }

.solutions__btn-step:after {
  display: block;
  content: "";
  width: 16px;
  height: 16px;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  -o-border-radius: 16px;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 13px;
  margin-left: -8px;
  background-color: #0d3b6d;
  -webkit-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transition-delay: 0s;
  transition-delay: 0s; }

.solutions__btn-step:not(.active):hover:after {
  background-color: #fff; }

.solutions__btn-step.active span {
  color: #fff; }

.solutions__btn-step.active:after {
  width: 24px;
  height: 24px;
  -webkit-border-radius: 24px;
  -moz-border-radius: 24px;
  -o-border-radius: 24px;
  border-radius: 24px;
  top: 8px;
  margin-left: -12px;
  border-top: 4px solid #fff;
  border-right: 4px solid #fff;
  border-bottom: 4px solid #fff;
  border-left: 4px solid #fff; }

@media (min-width: 448px) {
  .solutions__content {
    min-height: 270px; } }

@media (min-width: 544px) {
  .solutions__content {
    min-height: 240px; } }

@media (min-width: 768px) {
  .solutions__content {
    min-height: 230px; }
  .solutions__stage .solutions__imagewrapper a.icon {
    width: 30px;
    height: 40px;
    margin-top: -20px; }
  .solutions__stage .solutions__imagewrapper a.icon:before {
    font-size: 1.75rem; } }

@media (min-width: 1000px) {
  .solutions__btn-step {
    height: 80px;
    padding-top: 40px; }
  .solutions__btn-step span {
    display: block; } }

@media (min-width: 1280px) {
  .solutions__overlay {
    position: absolute;
    left: 0px;
    top: 0px;
    background: none; }
  .solutions__overlay .container, .solutions__overlay .row, .solutions__overlay .col {
    height: 100%; }
  .solutions__content {
    min-height: 1px;
    margin: 2.0rem 0 0 0;
    padding: 2.25rem 2.0rem 2.625rem 2.0rem;
    /*@include bgaw(0.95);*/
    background-color: #f0f0f0; }
  .solutions__content .btn {
    padding: 0.5rem 1.5rem; }
  .solutions__controls {
    margin-top: -1px;
    padding: 1rem 0 1rem 0; }
  .solutions__stage.step-4 svg.img-main {
    margin-left: 20%; }
  .solutions__stage.step-5 svg.img-main {
    margin-left: 0%; }
  .solutions__stage.step-6 svg.img-main {
    margin-left: -25%; }
  .solutions__stage .solutions__imagewrapper a.icon {
    display: none; }
  .solutions__stage > a.icon {
    display: block; } }
// solution ------  end  ------
// Global ------ start ------
.container {
  margin-left: auto;
  margin-right: auto;
  padding-left: 0.625rem;
  padding-right: 0.625rem; }
.container::after {
  content: "";
  display: table;
  clear: both; }
@media (min-width: 448px) {
  .container {
    max-width: 448px; } }
@media (min-width: 544px) {
  .container {
    max-width: 544px; } }
@media (min-width: 768px) {
  .container {
    max-width: 720px; } }
@media (min-width: 1000px) {
  .container {
    max-width: 960px; } }
@media (min-width: 1280px) {
  .container {
    max-width: 1240px; } }
@media (min-width: 1440px) {
  .container {
    max-width: 1240px; } }

.container-fluid {
  margin-left: auto;
  margin-right: auto;
  padding-left: 0.625rem;
  padding-right: 0.625rem; }
.container-fluid::after {
  content: "";
  display: table;
  clear: both; }

.row {
  margin-left: -0.625rem;
  margin-right: -0.625rem; }
.row::after {
  content: "";
  display: table;
  clear: both; }

.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-13, .col-xs-14, .col-xs-15, .col-xs-16, .col-xs-17, .col-xs-18, .col-xs-19, .col-xs-20, .col-xs-21, .col-xs-22, .col-xs-23, .col-xs-24, .col-vsm-1, .col-vsm-2, .col-vsm-3, .col-vsm-4, .col-vsm-5, .col-vsm-6, .col-vsm-7, .col-vsm-8, .col-vsm-9, .col-vsm-10, .col-vsm-11, .col-vsm-12, .col-vsm-13, .col-vsm-14, .col-vsm-15, .col-vsm-16, .col-vsm-17, .col-vsm-18, .col-vsm-19, .col-vsm-20, .col-vsm-21, .col-vsm-22, .col-vsm-23, .col-vsm-24, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-13, .col-sm-14, .col-sm-15, .col-sm-16, .col-sm-17, .col-sm-18, .col-sm-19, .col-sm-20, .col-sm-21, .col-sm-22, .col-sm-23, .col-sm-24, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md-13, .col-md-14, .col-md-15, .col-md-16, .col-md-17, .col-md-18, .col-md-19, .col-md-20, .col-md-21, .col-md-22, .col-md-23, .col-md-24, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-13, .col-lg-14, .col-lg-15, .col-lg-16, .col-lg-17, .col-lg-18, .col-lg-19, .col-lg-20, .col-lg-21, .col-lg-22, .col-lg-23, .col-lg-24, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-13, .col-xl-14, .col-xl-15, .col-xl-16, .col-xl-17, .col-xl-18, .col-xl-19, .col-xl-20, .col-xl-21, .col-xl-22, .col-xl-23, .col-xl-24, .col-xxl-1, .col-xxl-2, .col-xxl-3, .col-xxl-4, .col-xxl-5, .col-xxl-6, .col-xxl-7, .col-xxl-8, .col-xxl-9, .col-xxl-10, .col-xxl-11, .col-xxl-12, .col-xxl-13, .col-xxl-14, .col-xxl-15, .col-xxl-16, .col-xxl-17, .col-xxl-18, .col-xxl-19, .col-xxl-20, .col-xxl-21, .col-xxl-22, .col-xxl-23, .col-xxl-24 {
  position: relative;
  min-height: 1px;
  padding-left: 0.625rem;
  padding-right: 0.625rem; }

.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-13, .col-xs-14, .col-xs-15, .col-xs-16, .col-xs-17, .col-xs-18, .col-xs-19, .col-xs-20, .col-xs-21, .col-xs-22, .col-xs-23, .col-xs-24 {
  float: left; }

.col-xs-1 {
  width: 4.1666666667%; }

.col-xs-2 {
  width: 8.3333333333%; }

.col-xs-3 {
  width: 12.5%; }

.col-xs-4 {
  width: 16.6666666667%; }

.col-xs-5 {
  width: 20.8333333333%; }

.col-xs-6 {
  width: 25%; }

.col-xs-7 {
  width: 29.1666666667%; }

.col-xs-8 {
  width: 33.3333333333%; }

.col-xs-9 {
  width: 37.5%; }

.col-xs-10 {
  width: 41.6666666667%; }

.col-xs-11 {
  width: 45.8333333333%; }

.col-xs-12 {
  width: 50%; }

.col-xs-13 {
  width: 54.1666666667%; }

.col-xs-14 {
  width: 58.3333333333%; }

.col-xs-15 {
  width: 62.5%; }

.col-xs-16 {
  width: 66.6666666667%; }

.col-xs-17 {
  width: 70.8333333333%; }

.col-xs-18 {
  width: 75%; }

.col-xs-19 {
  width: 79.1666666667%; }

.col-xs-20 {
  width: 83.3333333333%; }

.col-xs-21 {
  width: 87.5%; }

.col-xs-22 {
  width: 91.6666666667%; }

.col-xs-23 {
  width: 95.8333333333%; }

.col-xs-24 {
  width: 100%; }

.col-xs-pull-0 {
  right: auto; }

.col-xs-pull-1 {
  right: 4.1666666667%; }

.col-xs-pull-2 {
  right: 8.3333333333%; }

.col-xs-pull-3 {
  right: 12.5%; }

.col-xs-pull-4 {
  right: 16.6666666667%; }

.col-xs-pull-5 {
  right: 20.8333333333%; }

.col-xs-pull-6 {
  right: 25%; }

.col-xs-pull-7 {
  right: 29.1666666667%; }

.col-xs-pull-8 {
  right: 33.3333333333%; }

.col-xs-pull-9 {
  right: 37.5%; }

.col-xs-pull-10 {
  right: 41.6666666667%; }

.col-xs-pull-11 {
  right: 45.8333333333%; }

.col-xs-pull-12 {
  right: 50%; }

.col-xs-pull-13 {
  right: 54.1666666667%; }

.col-xs-pull-14 {
  right: 58.3333333333%; }

.col-xs-pull-15 {
  right: 62.5%; }

.col-xs-pull-16 {
  right: 66.6666666667%; }

.col-xs-pull-17 {
  right: 70.8333333333%; }

.col-xs-pull-18 {
  right: 75%; }

.col-xs-pull-19 {
  right: 79.1666666667%; }

.col-xs-pull-20 {
  right: 83.3333333333%; }

.col-xs-pull-21 {
  right: 87.5%; }

.col-xs-pull-22 {
  right: 91.6666666667%; }

.col-xs-pull-23 {
  right: 95.8333333333%; }

.col-xs-pull-24 {
  right: 100%; }

.col-xs-push-0 {
  left: auto; }

.col-xs-push-1 {
  left: 4.1666666667%; }

.col-xs-push-2 {
  left: 8.3333333333%; }

.col-xs-push-3 {
  left: 12.5%; }

.col-xs-push-4 {
  left: 16.6666666667%; }

.col-xs-push-5 {
  left: 20.8333333333%; }

.col-xs-push-6 {
  left: 25%; }

.col-xs-push-7 {
  left: 29.1666666667%; }

.col-xs-push-8 {
  left: 33.3333333333%; }

.col-xs-push-9 {
  left: 37.5%; }

.col-xs-push-10 {
  left: 41.6666666667%; }

.col-xs-push-11 {
  left: 45.8333333333%; }

.col-xs-push-12 {
  left: 50%; }

.col-xs-push-13 {
  left: 54.1666666667%; }

.col-xs-push-14 {
  left: 58.3333333333%; }

.col-xs-push-15 {
  left: 62.5%; }

.col-xs-push-16 {
  left: 66.6666666667%; }

.col-xs-push-17 {
  left: 70.8333333333%; }

.col-xs-push-18 {
  left: 75%; }

.col-xs-push-19 {
  left: 79.1666666667%; }

.col-xs-push-20 {
  left: 83.3333333333%; }

.col-xs-push-21 {
  left: 87.5%; }

.col-xs-push-22 {
  left: 91.6666666667%; }

.col-xs-push-23 {
  left: 95.8333333333%; }

.col-xs-push-24 {
  left: 100%; }

.col-xs-offset-0 {
  margin-left: 0%; }

.col-xs-offset-1 {
  margin-left: 4.1666666667%; }

.col-xs-offset-2 {
  margin-left: 8.3333333333%; }

.col-xs-offset-3 {
  margin-left: 12.5%; }

.col-xs-offset-4 {
  margin-left: 16.6666666667%; }

.col-xs-offset-5 {
  margin-left: 20.8333333333%; }

.col-xs-offset-6 {
  margin-left: 25%; }

.col-xs-offset-7 {
  margin-left: 29.1666666667%; }

.col-xs-offset-8 {
  margin-left: 33.3333333333%; }

.col-xs-offset-9 {
  margin-left: 37.5%; }

.col-xs-offset-10 {
  margin-left: 41.6666666667%; }

.col-xs-offset-11 {
  margin-left: 45.8333333333%; }

.col-xs-offset-12 {
  margin-left: 50%; }

.col-xs-offset-13 {
  margin-left: 54.1666666667%; }

.col-xs-offset-14 {
  margin-left: 58.3333333333%; }

.col-xs-offset-15 {
  margin-left: 62.5%; }

.col-xs-offset-16 {
  margin-left: 66.6666666667%; }

.col-xs-offset-17 {
  margin-left: 70.8333333333%; }

.col-xs-offset-18 {
  margin-left: 75%; }

.col-xs-offset-19 {
  margin-left: 79.1666666667%; }

.col-xs-offset-20 {
  margin-left: 83.3333333333%; }

.col-xs-offset-21 {
  margin-left: 87.5%; }

.col-xs-offset-22 {
  margin-left: 91.6666666667%; }

.col-xs-offset-23 {
  margin-left: 95.8333333333%; }

.col-xs-offset-24 {
  margin-left: 100%; }

@media (min-width: 448px) {
  .col-vsm-1, .col-vsm-2, .col-vsm-3, .col-vsm-4, .col-vsm-5, .col-vsm-6, .col-vsm-7, .col-vsm-8, .col-vsm-9, .col-vsm-10, .col-vsm-11, .col-vsm-12, .col-vsm-13, .col-vsm-14, .col-vsm-15, .col-vsm-16, .col-vsm-17, .col-vsm-18, .col-vsm-19, .col-vsm-20, .col-vsm-21, .col-vsm-22, .col-vsm-23, .col-vsm-24 {
    float: left; }
  .col-vsm-1 {
    width: 4.1666666667%; }
  .col-vsm-2 {
    width: 8.3333333333%; }
  .col-vsm-3 {
    width: 12.5%; }
  .col-vsm-4 {
    width: 16.6666666667%; }
  .col-vsm-5 {
    width: 20.8333333333%; }
  .col-vsm-6 {
    width: 25%; }
  .col-vsm-7 {
    width: 29.1666666667%; }
  .col-vsm-8 {
    width: 33.3333333333%; }
  .col-vsm-9 {
    width: 37.5%; }
  .col-vsm-10 {
    width: 41.6666666667%; }
  .col-vsm-11 {
    width: 45.8333333333%; }
  .col-vsm-12 {
    width: 50%; }
  .col-vsm-13 {
    width: 54.1666666667%; }
  .col-vsm-14 {
    width: 58.3333333333%; }
  .col-vsm-15 {
    width: 62.5%; }
  .col-vsm-16 {
    width: 66.6666666667%; }
  .col-vsm-17 {
    width: 70.8333333333%; }
  .col-vsm-18 {
    width: 75%; }
  .col-vsm-19 {
    width: 79.1666666667%; }
  .col-vsm-20 {
    width: 83.3333333333%; }
  .col-vsm-21 {
    width: 87.5%; }
  .col-vsm-22 {
    width: 91.6666666667%; }
  .col-vsm-23 {
    width: 95.8333333333%; }
  .col-vsm-24 {
    width: 100%; }
  .col-vsm-pull-0 {
    right: auto; }
  .col-vsm-pull-1 {
    right: 4.1666666667%; }
  .col-vsm-pull-2 {
    right: 8.3333333333%; }
  .col-vsm-pull-3 {
    right: 12.5%; }
  .col-vsm-pull-4 {
    right: 16.6666666667%; }
  .col-vsm-pull-5 {
    right: 20.8333333333%; }
  .col-vsm-pull-6 {
    right: 25%; }
  .col-vsm-pull-7 {
    right: 29.1666666667%; }
  .col-vsm-pull-8 {
    right: 33.3333333333%; }
  .col-vsm-pull-9 {
    right: 37.5%; }
  .col-vsm-pull-10 {
    right: 41.6666666667%; }
  .col-vsm-pull-11 {
    right: 45.8333333333%; }
  .col-vsm-pull-12 {
    right: 50%; }
  .col-vsm-pull-13 {
    right: 54.1666666667%; }
  .col-vsm-pull-14 {
    right: 58.3333333333%; }
  .col-vsm-pull-15 {
    right: 62.5%; }
  .col-vsm-pull-16 {
    right: 66.6666666667%; }
  .col-vsm-pull-17 {
    right: 70.8333333333%; }
  .col-vsm-pull-18 {
    right: 75%; }
  .col-vsm-pull-19 {
    right: 79.1666666667%; }
  .col-vsm-pull-20 {
    right: 83.3333333333%; }
  .col-vsm-pull-21 {
    right: 87.5%; }
  .col-vsm-pull-22 {
    right: 91.6666666667%; }
  .col-vsm-pull-23 {
    right: 95.8333333333%; }
  .col-vsm-pull-24 {
    right: 100%; }
  .col-vsm-push-0 {
    left: auto; }
  .col-vsm-push-1 {
    left: 4.1666666667%; }
  .col-vsm-push-2 {
    left: 8.3333333333%; }
  .col-vsm-push-3 {
    left: 12.5%; }
  .col-vsm-push-4 {
    left: 16.6666666667%; }
  .col-vsm-push-5 {
    left: 20.8333333333%; }
  .col-vsm-push-6 {
    left: 25%; }
  .col-vsm-push-7 {
    left: 29.1666666667%; }
  .col-vsm-push-8 {
    left: 33.3333333333%; }
  .col-vsm-push-9 {
    left: 37.5%; }
  .col-vsm-push-10 {
    left: 41.6666666667%; }
  .col-vsm-push-11 {
    left: 45.8333333333%; }
  .col-vsm-push-12 {
    left: 50%; }
  .col-vsm-push-13 {
    left: 54.1666666667%; }
  .col-vsm-push-14 {
    left: 58.3333333333%; }
  .col-vsm-push-15 {
    left: 62.5%; }
  .col-vsm-push-16 {
    left: 66.6666666667%; }
  .col-vsm-push-17 {
    left: 70.8333333333%; }
  .col-vsm-push-18 {
    left: 75%; }
  .col-vsm-push-19 {
    left: 79.1666666667%; }
  .col-vsm-push-20 {
    left: 83.3333333333%; }
  .col-vsm-push-21 {
    left: 87.5%; }
  .col-vsm-push-22 {
    left: 91.6666666667%; }
  .col-vsm-push-23 {
    left: 95.8333333333%; }
  .col-vsm-push-24 {
    left: 100%; }
  .col-vsm-offset-0 {
    margin-left: 0%; }
  .col-vsm-offset-1 {
    margin-left: 4.1666666667%; }
  .col-vsm-offset-2 {
    margin-left: 8.3333333333%; }
  .col-vsm-offset-3 {
    margin-left: 12.5%; }
  .col-vsm-offset-4 {
    margin-left: 16.6666666667%; }
  .col-vsm-offset-5 {
    margin-left: 20.8333333333%; }
  .col-vsm-offset-6 {
    margin-left: 25%; }
  .col-vsm-offset-7 {
    margin-left: 29.1666666667%; }
  .col-vsm-offset-8 {
    margin-left: 33.3333333333%; }
  .col-vsm-offset-9 {
    margin-left: 37.5%; }
  .col-vsm-offset-10 {
    margin-left: 41.6666666667%; }
  .col-vsm-offset-11 {
    margin-left: 45.8333333333%; }
  .col-vsm-offset-12 {
    margin-left: 50%; }
  .col-vsm-offset-13 {
    margin-left: 54.1666666667%; }
  .col-vsm-offset-14 {
    margin-left: 58.3333333333%; }
  .col-vsm-offset-15 {
    margin-left: 62.5%; }
  .col-vsm-offset-16 {
    margin-left: 66.6666666667%; }
  .col-vsm-offset-17 {
    margin-left: 70.8333333333%; }
  .col-vsm-offset-18 {
    margin-left: 75%; }
  .col-vsm-offset-19 {
    margin-left: 79.1666666667%; }
  .col-vsm-offset-20 {
    margin-left: 83.3333333333%; }
  .col-vsm-offset-21 {
    margin-left: 87.5%; }
  .col-vsm-offset-22 {
    margin-left: 91.6666666667%; }
  .col-vsm-offset-23 {
    margin-left: 95.8333333333%; }
  .col-vsm-offset-24 {
    margin-left: 100%; } }

@media (min-width: 544px) {
  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-13, .col-sm-14, .col-sm-15, .col-sm-16, .col-sm-17, .col-sm-18, .col-sm-19, .col-sm-20, .col-sm-21, .col-sm-22, .col-sm-23, .col-sm-24 {
    float: left; }
  .col-sm-1 {
    width: 4.1666666667%; }
  .col-sm-2 {
    width: 8.3333333333%; }
  .col-sm-3 {
    width: 12.5%; }
  .col-sm-4 {
    width: 16.6666666667%; }
  .col-sm-5 {
    width: 20.8333333333%; }
  .col-sm-6 {
    width: 25%; }
  .col-sm-7 {
    width: 29.1666666667%; }
  .col-sm-8 {
    width: 33.3333333333%; }
  .col-sm-9 {
    width: 37.5%; }
  .col-sm-10 {
    width: 41.6666666667%; }
  .col-sm-11 {
    width: 45.8333333333%; }
  .col-sm-12 {
    width: 50%; }
  .col-sm-13 {
    width: 54.1666666667%; }
  .col-sm-14 {
    width: 58.3333333333%; }
  .col-sm-15 {
    width: 62.5%; }
  .col-sm-16 {
    width: 66.6666666667%; }
  .col-sm-17 {
    width: 70.8333333333%; }
  .col-sm-18 {
    width: 75%; }
  .col-sm-19 {
    width: 79.1666666667%; }
  .col-sm-20 {
    width: 83.3333333333%; }
  .col-sm-21 {
    width: 87.5%; }
  .col-sm-22 {
    width: 91.6666666667%; }
  .col-sm-23 {
    width: 95.8333333333%; }
  .col-sm-24 {
    width: 100%; }
  .col-sm-pull-0 {
    right: auto; }
  .col-sm-pull-1 {
    right: 4.1666666667%; }
  .col-sm-pull-2 {
    right: 8.3333333333%; }
  .col-sm-pull-3 {
    right: 12.5%; }
  .col-sm-pull-4 {
    right: 16.6666666667%; }
  .col-sm-pull-5 {
    right: 20.8333333333%; }
  .col-sm-pull-6 {
    right: 25%; }
  .col-sm-pull-7 {
    right: 29.1666666667%; }
  .col-sm-pull-8 {
    right: 33.3333333333%; }
  .col-sm-pull-9 {
    right: 37.5%; }
  .col-sm-pull-10 {
    right: 41.6666666667%; }
  .col-sm-pull-11 {
    right: 45.8333333333%; }
  .col-sm-pull-12 {
    right: 50%; }
  .col-sm-pull-13 {
    right: 54.1666666667%; }
  .col-sm-pull-14 {
    right: 58.3333333333%; }
  .col-sm-pull-15 {
    right: 62.5%; }
  .col-sm-pull-16 {
    right: 66.6666666667%; }
  .col-sm-pull-17 {
    right: 70.8333333333%; }
  .col-sm-pull-18 {
    right: 75%; }
  .col-sm-pull-19 {
    right: 79.1666666667%; }
  .col-sm-pull-20 {
    right: 83.3333333333%; }
  .col-sm-pull-21 {
    right: 87.5%; }
  .col-sm-pull-22 {
    right: 91.6666666667%; }
  .col-sm-pull-23 {
    right: 95.8333333333%; }
  .col-sm-pull-24 {
    right: 100%; }
  .col-sm-push-0 {
    left: auto; }
  .col-sm-push-1 {
    left: 4.1666666667%; }
  .col-sm-push-2 {
    left: 8.3333333333%; }
  .col-sm-push-3 {
    left: 12.5%; }
  .col-sm-push-4 {
    left: 16.6666666667%; }
  .col-sm-push-5 {
    left: 20.8333333333%; }
  .col-sm-push-6 {
    left: 25%; }
  .col-sm-push-7 {
    left: 29.1666666667%; }
  .col-sm-push-8 {
    left: 33.3333333333%; }
  .col-sm-push-9 {
    left: 37.5%; }
  .col-sm-push-10 {
    left: 41.6666666667%; }
  .col-sm-push-11 {
    left: 45.8333333333%; }
  .col-sm-push-12 {
    left: 50%; }
  .col-sm-push-13 {
    left: 54.1666666667%; }
  .col-sm-push-14 {
    left: 58.3333333333%; }
  .col-sm-push-15 {
    left: 62.5%; }
  .col-sm-push-16 {
    left: 66.6666666667%; }
  .col-sm-push-17 {
    left: 70.8333333333%; }
  .col-sm-push-18 {
    left: 75%; }
  .col-sm-push-19 {
    left: 79.1666666667%; }
  .col-sm-push-20 {
    left: 83.3333333333%; }
  .col-sm-push-21 {
    left: 87.5%; }
  .col-sm-push-22 {
    left: 91.6666666667%; }
  .col-sm-push-23 {
    left: 95.8333333333%; }
  .col-sm-push-24 {
    left: 100%; }
  .col-sm-offset-0 {
    margin-left: 0%; }
  .col-sm-offset-1 {
    margin-left: 4.1666666667%; }
  .col-sm-offset-2 {
    margin-left: 8.3333333333%; }
  .col-sm-offset-3 {
    margin-left: 12.5%; }
  .col-sm-offset-4 {
    margin-left: 16.6666666667%; }
  .col-sm-offset-5 {
    margin-left: 20.8333333333%; }
  .col-sm-offset-6 {
    margin-left: 25%; }
  .col-sm-offset-7 {
    margin-left: 29.1666666667%; }
  .col-sm-offset-8 {
    margin-left: 33.3333333333%; }
  .col-sm-offset-9 {
    margin-left: 37.5%; }
  .col-sm-offset-10 {
    margin-left: 41.6666666667%; }
  .col-sm-offset-11 {
    margin-left: 45.8333333333%; }
  .col-sm-offset-12 {
    margin-left: 50%; }
  .col-sm-offset-13 {
    margin-left: 54.1666666667%; }
  .col-sm-offset-14 {
    margin-left: 58.3333333333%; }
  .col-sm-offset-15 {
    margin-left: 62.5%; }
  .col-sm-offset-16 {
    margin-left: 66.6666666667%; }
  .col-sm-offset-17 {
    margin-left: 70.8333333333%; }
  .col-sm-offset-18 {
    margin-left: 75%; }
  .col-sm-offset-19 {
    margin-left: 79.1666666667%; }
  .col-sm-offset-20 {
    margin-left: 83.3333333333%; }
  .col-sm-offset-21 {
    margin-left: 87.5%; }
  .col-sm-offset-22 {
    margin-left: 91.6666666667%; }
  .col-sm-offset-23 {
    margin-left: 95.8333333333%; }
  .col-sm-offset-24 {
    margin-left: 100%; } }

@media (min-width: 768px) {
  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md-13, .col-md-14, .col-md-15, .col-md-16, .col-md-17, .col-md-18, .col-md-19, .col-md-20, .col-md-21, .col-md-22, .col-md-23, .col-md-24 {
    float: left; }
  .col-md-1 {
    width: 4.1666666667%; }
  .col-md-2 {
    width: 8.3333333333%; }
  .col-md-3 {
    width: 12.5%; }
  .col-md-4 {
    width: 16.6666666667%; }
  .col-md-5 {
    width: 20.8333333333%; }
  .col-md-6 {
    width: 25%; }
  .col-md-7 {
    width: 29.1666666667%; }
  .col-md-8 {
    width: 33.3333333333%; }
  .col-md-9 {
    width: 37.5%; }
  .col-md-10 {
    width: 41.6666666667%; }
  .col-md-11 {
    width: 45.8333333333%; }
  .col-md-12 {
    width: 50%; }
  .col-md-13 {
    width: 54.1666666667%; }
  .col-md-14 {
    width: 58.3333333333%; }
  .col-md-15 {
    width: 62.5%; }
  .col-md-16 {
    width: 66.6666666667%; }
  .col-md-17 {
    width: 70.8333333333%; }
  .col-md-18 {
    width: 75%; }
  .col-md-19 {
    width: 79.1666666667%; }
  .col-md-20 {
    width: 83.3333333333%; }
  .col-md-21 {
    width: 87.5%; }
  .col-md-22 {
    width: 91.6666666667%; }
  .col-md-23 {
    width: 95.8333333333%; }
  .col-md-24 {
    width: 100%; }
  .col-md-pull-0 {
    right: auto; }
  .col-md-pull-1 {
    right: 4.1666666667%; }
  .col-md-pull-2 {
    right: 8.3333333333%; }
  .col-md-pull-3 {
    right: 12.5%; }
  .col-md-pull-4 {
    right: 16.6666666667%; }
  .col-md-pull-5 {
    right: 20.8333333333%; }
  .col-md-pull-6 {
    right: 25%; }
  .col-md-pull-7 {
    right: 29.1666666667%; }
  .col-md-pull-8 {
    right: 33.3333333333%; }
  .col-md-pull-9 {
    right: 37.5%; }
  .col-md-pull-10 {
    right: 41.6666666667%; }
  .col-md-pull-11 {
    right: 45.8333333333%; }
  .col-md-pull-12 {
    right: 50%; }
  .col-md-pull-13 {
    right: 54.1666666667%; }
  .col-md-pull-14 {
    right: 58.3333333333%; }
  .col-md-pull-15 {
    right: 62.5%; }
  .col-md-pull-16 {
    right: 66.6666666667%; }
  .col-md-pull-17 {
    right: 70.8333333333%; }
  .col-md-pull-18 {
    right: 75%; }
  .col-md-pull-19 {
    right: 79.1666666667%; }
  .col-md-pull-20 {
    right: 83.3333333333%; }
  .col-md-pull-21 {
    right: 87.5%; }
  .col-md-pull-22 {
    right: 91.6666666667%; }
  .col-md-pull-23 {
    right: 95.8333333333%; }
  .col-md-pull-24 {
    right: 100%; }
  .col-md-push-0 {
    left: auto; }
  .col-md-push-1 {
    left: 4.1666666667%; }
  .col-md-push-2 {
    left: 8.3333333333%; }
  .col-md-push-3 {
    left: 12.5%; }
  .col-md-push-4 {
    left: 16.6666666667%; }
  .col-md-push-5 {
    left: 20.8333333333%; }
  .col-md-push-6 {
    left: 25%; }
  .col-md-push-7 {
    left: 29.1666666667%; }
  .col-md-push-8 {
    left: 33.3333333333%; }
  .col-md-push-9 {
    left: 37.5%; }
  .col-md-push-10 {
    left: 41.6666666667%; }
  .col-md-push-11 {
    left: 45.8333333333%; }
  .col-md-push-12 {
    left: 50%; }
  .col-md-push-13 {
    left: 54.1666666667%; }
  .col-md-push-14 {
    left: 58.3333333333%; }
  .col-md-push-15 {
    left: 62.5%; }
  .col-md-push-16 {
    left: 66.6666666667%; }
  .col-md-push-17 {
    left: 70.8333333333%; }
  .col-md-push-18 {
    left: 75%; }
  .col-md-push-19 {
    left: 79.1666666667%; }
  .col-md-push-20 {
    left: 83.3333333333%; }
  .col-md-push-21 {
    left: 87.5%; }
  .col-md-push-22 {
    left: 91.6666666667%; }
  .col-md-push-23 {
    left: 95.8333333333%; }
  .col-md-push-24 {
    left: 100%; }
  .col-md-offset-0 {
    margin-left: 0%; }
  .col-md-offset-1 {
    margin-left: 4.1666666667%; }
  .col-md-offset-2 {
    margin-left: 8.3333333333%; }
  .col-md-offset-3 {
    margin-left: 12.5%; }
  .col-md-offset-4 {
    margin-left: 16.6666666667%; }
  .col-md-offset-5 {
    margin-left: 20.8333333333%; }
  .col-md-offset-6 {
    margin-left: 25%; }
  .col-md-offset-7 {
    margin-left: 29.1666666667%; }
  .col-md-offset-8 {
    margin-left: 33.3333333333%; }
  .col-md-offset-9 {
    margin-left: 37.5%; }
  .col-md-offset-10 {
    margin-left: 41.6666666667%; }
  .col-md-offset-11 {
    margin-left: 45.8333333333%; }
  .col-md-offset-12 {
    margin-left: 50%; }
  .col-md-offset-13 {
    margin-left: 54.1666666667%; }
  .col-md-offset-14 {
    margin-left: 58.3333333333%; }
  .col-md-offset-15 {
    margin-left: 62.5%; }
  .col-md-offset-16 {
    margin-left: 66.6666666667%; }
  .col-md-offset-17 {
    margin-left: 70.8333333333%; }
  .col-md-offset-18 {
    margin-left: 75%; }
  .col-md-offset-19 {
    margin-left: 79.1666666667%; }
  .col-md-offset-20 {
    margin-left: 83.3333333333%; }
  .col-md-offset-21 {
    margin-left: 87.5%; }
  .col-md-offset-22 {
    margin-left: 91.6666666667%; }
  .col-md-offset-23 {
    margin-left: 95.8333333333%; }
  .col-md-offset-24 {
    margin-left: 100%; } }

@media (min-width: 1000px) {
  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-13, .col-lg-14, .col-lg-15, .col-lg-16, .col-lg-17, .col-lg-18, .col-lg-19, .col-lg-20, .col-lg-21, .col-lg-22, .col-lg-23, .col-lg-24 {
    float: left; }
  .col-lg-1 {
    width: 4.1666666667%; }
  .col-lg-2 {
    width: 8.3333333333%; }
  .col-lg-3 {
    width: 12.5%; }
  .col-lg-4 {
    width: 16.6666666667%; }
  .col-lg-5 {
    width: 20.8333333333%; }
  .col-lg-6 {
    width: 25%; }
  .col-lg-7 {
    width: 29.1666666667%; }
  .col-lg-8 {
    width: 33.3333333333%; }
  .col-lg-9 {
    width: 37.5%; }
  .col-lg-10 {
    width: 41.6666666667%; }
  .col-lg-11 {
    width: 45.8333333333%; }
  .col-lg-12 {
    width: 50%; }
  .col-lg-13 {
    width: 54.1666666667%; }
  .col-lg-14 {
    width: 58.3333333333%; }
  .col-lg-15 {
    width: 62.5%; }
  .col-lg-16 {
    width: 66.6666666667%; }
  .col-lg-17 {
    width: 70.8333333333%; }
  .col-lg-18 {
    width: 75%; }
  .col-lg-19 {
    width: 79.1666666667%; }
  .col-lg-20 {
    width: 83.3333333333%; }
  .col-lg-21 {
    width: 87.5%; }
  .col-lg-22 {
    width: 91.6666666667%; }
  .col-lg-23 {
    width: 95.8333333333%; }
  .col-lg-24 {
    width: 100%; }
  .col-lg-pull-0 {
    right: auto; }
  .col-lg-pull-1 {
    right: 4.1666666667%; }
  .col-lg-pull-2 {
    right: 8.3333333333%; }
  .col-lg-pull-3 {
    right: 12.5%; }
  .col-lg-pull-4 {
    right: 16.6666666667%; }
  .col-lg-pull-5 {
    right: 20.8333333333%; }
  .col-lg-pull-6 {
    right: 25%; }
  .col-lg-pull-7 {
    right: 29.1666666667%; }
  .col-lg-pull-8 {
    right: 33.3333333333%; }
  .col-lg-pull-9 {
    right: 37.5%; }
  .col-lg-pull-10 {
    right: 41.6666666667%; }
  .col-lg-pull-11 {
    right: 45.8333333333%; }
  .col-lg-pull-12 {
    right: 50%; }
  .col-lg-pull-13 {
    right: 54.1666666667%; }
  .col-lg-pull-14 {
    right: 58.3333333333%; }
  .col-lg-pull-15 {
    right: 62.5%; }
  .col-lg-pull-16 {
    right: 66.6666666667%; }
  .col-lg-pull-17 {
    right: 70.8333333333%; }
  .col-lg-pull-18 {
    right: 75%; }
  .col-lg-pull-19 {
    right: 79.1666666667%; }
  .col-lg-pull-20 {
    right: 83.3333333333%; }
  .col-lg-pull-21 {
    right: 87.5%; }
  .col-lg-pull-22 {
    right: 91.6666666667%; }
  .col-lg-pull-23 {
    right: 95.8333333333%; }
  .col-lg-pull-24 {
    right: 100%; }
  .col-lg-push-0 {
    left: auto; }
  .col-lg-push-1 {
    left: 4.1666666667%; }
  .col-lg-push-2 {
    left: 8.3333333333%; }
  .col-lg-push-3 {
    left: 12.5%; }
  .col-lg-push-4 {
    left: 16.6666666667%; }
  .col-lg-push-5 {
    left: 20.8333333333%; }
  .col-lg-push-6 {
    left: 25%; }
  .col-lg-push-7 {
    left: 29.1666666667%; }
  .col-lg-push-8 {
    left: 33.3333333333%; }
  .col-lg-push-9 {
    left: 37.5%; }
  .col-lg-push-10 {
    left: 41.6666666667%; }
  .col-lg-push-11 {
    left: 45.8333333333%; }
  .col-lg-push-12 {
    left: 50%; }
  .col-lg-push-13 {
    left: 54.1666666667%; }
  .col-lg-push-14 {
    left: 58.3333333333%; }
  .col-lg-push-15 {
    left: 62.5%; }
  .col-lg-push-16 {
    left: 66.6666666667%; }
  .col-lg-push-17 {
    left: 70.8333333333%; }
  .col-lg-push-18 {
    left: 75%; }
  .col-lg-push-19 {
    left: 79.1666666667%; }
  .col-lg-push-20 {
    left: 83.3333333333%; }
  .col-lg-push-21 {
    left: 87.5%; }
  .col-lg-push-22 {
    left: 91.6666666667%; }
  .col-lg-push-23 {
    left: 95.8333333333%; }
  .col-lg-push-24 {
    left: 100%; }
  .col-lg-offset-0 {
    margin-left: 0%; }
  .col-lg-offset-1 {
    margin-left: 4.1666666667%; }
  .col-lg-offset-2 {
    margin-left: 8.3333333333%; }
  .col-lg-offset-3 {
    margin-left: 12.5%; }
  .col-lg-offset-4 {
    margin-left: 16.6666666667%; }
  .col-lg-offset-5 {
    margin-left: 20.8333333333%; }
  .col-lg-offset-6 {
    margin-left: 25%; }
  .col-lg-offset-7 {
    margin-left: 29.1666666667%; }
  .col-lg-offset-8 {
    margin-left: 33.3333333333%; }
  .col-lg-offset-9 {
    margin-left: 37.5%; }
  .col-lg-offset-10 {
    margin-left: 41.6666666667%; }
  .col-lg-offset-11 {
    margin-left: 45.8333333333%; }
  .col-lg-offset-12 {
    margin-left: 50%; }
  .col-lg-offset-13 {
    margin-left: 54.1666666667%; }
  .col-lg-offset-14 {
    margin-left: 58.3333333333%; }
  .col-lg-offset-15 {
    margin-left: 62.5%; }
  .col-lg-offset-16 {
    margin-left: 66.6666666667%; }
  .col-lg-offset-17 {
    margin-left: 70.8333333333%; }
  .col-lg-offset-18 {
    margin-left: 75%; }
  .col-lg-offset-19 {
    margin-left: 79.1666666667%; }
  .col-lg-offset-20 {
    margin-left: 83.3333333333%; }
  .col-lg-offset-21 {
    margin-left: 87.5%; }
  .col-lg-offset-22 {
    margin-left: 91.6666666667%; }
  .col-lg-offset-23 {
    margin-left: 95.8333333333%; }
  .col-lg-offset-24 {
    margin-left: 100%; } }

@media (min-width: 1280px) {
  .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-13, .col-xl-14, .col-xl-15, .col-xl-16, .col-xl-17, .col-xl-18, .col-xl-19, .col-xl-20, .col-xl-21, .col-xl-22, .col-xl-23, .col-xl-24 {
    float: left; }
  .col-xl-1 {
    width: 4.1666666667%; }
  .col-xl-2 {
    width: 8.3333333333%; }
  .col-xl-3 {
    width: 12.5%; }
  .col-xl-4 {
    width: 16.6666666667%; }
  .col-xl-5 {
    width: 20.8333333333%; }
  .col-xl-6 {
    width: 25%; }
  .col-xl-7 {
    width: 29.1666666667%; }
  .col-xl-8 {
    width: 33.3333333333%; }
  .col-xl-9 {
    width: 37.5%; }
  .col-xl-10 {
    width: 41.6666666667%; }
  .col-xl-11 {
    width: 45.8333333333%; }
  .col-xl-12 {
    width: 50%; }
  .col-xl-13 {
    width: 54.1666666667%; }
  .col-xl-14 {
    width: 58.3333333333%; }
  .col-xl-15 {
    width: 62.5%; }
  .col-xl-16 {
    width: 66.6666666667%; }
  .col-xl-17 {
    width: 70.8333333333%; }
  .col-xl-18 {
    width: 75%; }
  .col-xl-19 {
    width: 79.1666666667%; }
  .col-xl-20 {
    width: 83.3333333333%; }
  .col-xl-21 {
    width: 87.5%; }
  .col-xl-22 {
    width: 91.6666666667%; }
  .col-xl-23 {
    width: 95.8333333333%; }
  .col-xl-24 {
    width: 100%; }
  .col-xl-pull-0 {
    right: auto; }
  .col-xl-pull-1 {
    right: 4.1666666667%; }
  .col-xl-pull-2 {
    right: 8.3333333333%; }
  .col-xl-pull-3 {
    right: 12.5%; }
  .col-xl-pull-4 {
    right: 16.6666666667%; }
  .col-xl-pull-5 {
    right: 20.8333333333%; }
  .col-xl-pull-6 {
    right: 25%; }
  .col-xl-pull-7 {
    right: 29.1666666667%; }
  .col-xl-pull-8 {
    right: 33.3333333333%; }
  .col-xl-pull-9 {
    right: 37.5%; }
  .col-xl-pull-10 {
    right: 41.6666666667%; }
  .col-xl-pull-11 {
    right: 45.8333333333%; }
  .col-xl-pull-12 {
    right: 50%; }
  .col-xl-pull-13 {
    right: 54.1666666667%; }
  .col-xl-pull-14 {
    right: 58.3333333333%; }
  .col-xl-pull-15 {
    right: 62.5%; }
  .col-xl-pull-16 {
    right: 66.6666666667%; }
  .col-xl-pull-17 {
    right: 70.8333333333%; }
  .col-xl-pull-18 {
    right: 75%; }
  .col-xl-pull-19 {
    right: 79.1666666667%; }
  .col-xl-pull-20 {
    right: 83.3333333333%; }
  .col-xl-pull-21 {
    right: 87.5%; }
  .col-xl-pull-22 {
    right: 91.6666666667%; }
  .col-xl-pull-23 {
    right: 95.8333333333%; }
  .col-xl-pull-24 {
    right: 100%; }
  .col-xl-push-0 {
    left: auto; }
  .col-xl-push-1 {
    left: 4.1666666667%; }
  .col-xl-push-2 {
    left: 8.3333333333%; }
  .col-xl-push-3 {
    left: 12.5%; }
  .col-xl-push-4 {
    left: 16.6666666667%; }
  .col-xl-push-5 {
    left: 20.8333333333%; }
  .col-xl-push-6 {
    left: 25%; }
  .col-xl-push-7 {
    left: 29.1666666667%; }
  .col-xl-push-8 {
    left: 33.3333333333%; }
  .col-xl-push-9 {
    left: 37.5%; }
  .col-xl-push-10 {
    left: 41.6666666667%; }
  .col-xl-push-11 {
    left: 45.8333333333%; }
  .col-xl-push-12 {
    left: 50%; }
  .col-xl-push-13 {
    left: 54.1666666667%; }
  .col-xl-push-14 {
    left: 58.3333333333%; }
  .col-xl-push-15 {
    left: 62.5%; }
  .col-xl-push-16 {
    left: 66.6666666667%; }
  .col-xl-push-17 {
    left: 70.8333333333%; }
  .col-xl-push-18 {
    left: 75%; }
  .col-xl-push-19 {
    left: 79.1666666667%; }
  .col-xl-push-20 {
    left: 83.3333333333%; }
  .col-xl-push-21 {
    left: 87.5%; }
  .col-xl-push-22 {
    left: 91.6666666667%; }
  .col-xl-push-23 {
    left: 95.8333333333%; }
  .col-xl-push-24 {
    left: 100%; }
  .col-xl-offset-0 {
    margin-left: 0%; }
  .col-xl-offset-1 {
    margin-left: 4.1666666667%; }
  .col-xl-offset-2 {
    margin-left: 8.3333333333%; }
  .col-xl-offset-3 {
    margin-left: 12.5%; }
  .col-xl-offset-4 {
    margin-left: 16.6666666667%; }
  .col-xl-offset-5 {
    margin-left: 20.8333333333%; }
  .col-xl-offset-6 {
    margin-left: 25%; }
  .col-xl-offset-7 {
    margin-left: 29.1666666667%; }
  .col-xl-offset-8 {
    margin-left: 33.3333333333%; }
  .col-xl-offset-9 {
    margin-left: 37.5%; }
  .col-xl-offset-10 {
    margin-left: 41.6666666667%; }
  .col-xl-offset-11 {
    margin-left: 45.8333333333%; }
  .col-xl-offset-12 {
    margin-left: 50%; }
  .col-xl-offset-13 {
    margin-left: 54.1666666667%; }
  .col-xl-offset-14 {
    margin-left: 58.3333333333%; }
  .col-xl-offset-15 {
    margin-left: 62.5%; }
  .col-xl-offset-16 {
    margin-left: 66.6666666667%; }
  .col-xl-offset-17 {
    margin-left: 70.8333333333%; }
  .col-xl-offset-18 {
    margin-left: 75%; }
  .col-xl-offset-19 {
    margin-left: 79.1666666667%; }
  .col-xl-offset-20 {
    margin-left: 83.3333333333%; }
  .col-xl-offset-21 {
    margin-left: 87.5%; }
  .col-xl-offset-22 {
    margin-left: 91.6666666667%; }
  .col-xl-offset-23 {
    margin-left: 95.8333333333%; }
  .col-xl-offset-24 {
    margin-left: 100%; } }

@media (min-width: 1440px) {
  .col-xxl-1, .col-xxl-2, .col-xxl-3, .col-xxl-4, .col-xxl-5, .col-xxl-6, .col-xxl-7, .col-xxl-8, .col-xxl-9, .col-xxl-10, .col-xxl-11, .col-xxl-12, .col-xxl-13, .col-xxl-14, .col-xxl-15, .col-xxl-16, .col-xxl-17, .col-xxl-18, .col-xxl-19, .col-xxl-20, .col-xxl-21, .col-xxl-22, .col-xxl-23, .col-xxl-24 {
    float: left; }
  .col-xxl-1 {
    width: 4.1666666667%; }
  .col-xxl-2 {
    width: 8.3333333333%; }
  .col-xxl-3 {
    width: 12.5%; }
  .col-xxl-4 {
    width: 16.6666666667%; }
  .col-xxl-5 {
    width: 20.8333333333%; }
  .col-xxl-6 {
    width: 25%; }
  .col-xxl-7 {
    width: 29.1666666667%; }
  .col-xxl-8 {
    width: 33.3333333333%; }
  .col-xxl-9 {
    width: 37.5%; }
  .col-xxl-10 {
    width: 41.6666666667%; }
  .col-xxl-11 {
    width: 45.8333333333%; }
  .col-xxl-12 {
    width: 50%; }
  .col-xxl-13 {
    width: 54.1666666667%; }
  .col-xxl-14 {
    width: 58.3333333333%; }
  .col-xxl-15 {
    width: 62.5%; }
  .col-xxl-16 {
    width: 66.6666666667%; }
  .col-xxl-17 {
    width: 70.8333333333%; }
  .col-xxl-18 {
    width: 75%; }
  .col-xxl-19 {
    width: 79.1666666667%; }
  .col-xxl-20 {
    width: 83.3333333333%; }
  .col-xxl-21 {
    width: 87.5%; }
  .col-xxl-22 {
    width: 91.6666666667%; }
  .col-xxl-23 {
    width: 95.8333333333%; }
  .col-xxl-24 {
    width: 100%; }
  .col-xxl-pull-0 {
    right: auto; }
  .col-xxl-pull-1 {
    right: 4.1666666667%; }
  .col-xxl-pull-2 {
    right: 8.3333333333%; }
  .col-xxl-pull-3 {
    right: 12.5%; }
  .col-xxl-pull-4 {
    right: 16.6666666667%; }
  .col-xxl-pull-5 {
    right: 20.8333333333%; }
  .col-xxl-pull-6 {
    right: 25%; }
  .col-xxl-pull-7 {
    right: 29.1666666667%; }
  .col-xxl-pull-8 {
    right: 33.3333333333%; }
  .col-xxl-pull-9 {
    right: 37.5%; }
  .col-xxl-pull-10 {
    right: 41.6666666667%; }
  .col-xxl-pull-11 {
    right: 45.8333333333%; }
  .col-xxl-pull-12 {
    right: 50%; }
  .col-xxl-pull-13 {
    right: 54.1666666667%; }
  .col-xxl-pull-14 {
    right: 58.3333333333%; }
  .col-xxl-pull-15 {
    right: 62.5%; }
  .col-xxl-pull-16 {
    right: 66.6666666667%; }
  .col-xxl-pull-17 {
    right: 70.8333333333%; }
  .col-xxl-pull-18 {
    right: 75%; }
  .col-xxl-pull-19 {
    right: 79.1666666667%; }
  .col-xxl-pull-20 {
    right: 83.3333333333%; }
  .col-xxl-pull-21 {
    right: 87.5%; }
  .col-xxl-pull-22 {
    right: 91.6666666667%; }
  .col-xxl-pull-23 {
    right: 95.8333333333%; }
  .col-xxl-pull-24 {
    right: 100%; }
  .col-xxl-push-0 {
    left: auto; }
  .col-xxl-push-1 {
    left: 4.1666666667%; }
  .col-xxl-push-2 {
    left: 8.3333333333%; }
  .col-xxl-push-3 {
    left: 12.5%; }
  .col-xxl-push-4 {
    left: 16.6666666667%; }
  .col-xxl-push-5 {
    left: 20.8333333333%; }
  .col-xxl-push-6 {
    left: 25%; }
  .col-xxl-push-7 {
    left: 29.1666666667%; }
  .col-xxl-push-8 {
    left: 33.3333333333%; }
  .col-xxl-push-9 {
    left: 37.5%; }
  .col-xxl-push-10 {
    left: 41.6666666667%; }
  .col-xxl-push-11 {
    left: 45.8333333333%; }
  .col-xxl-push-12 {
    left: 50%; }
  .col-xxl-push-13 {
    left: 54.1666666667%; }
  .col-xxl-push-14 {
    left: 58.3333333333%; }
  .col-xxl-push-15 {
    left: 62.5%; }
  .col-xxl-push-16 {
    left: 66.6666666667%; }
  .col-xxl-push-17 {
    left: 70.8333333333%; }
  .col-xxl-push-18 {
    left: 75%; }
  .col-xxl-push-19 {
    left: 79.1666666667%; }
  .col-xxl-push-20 {
    left: 83.3333333333%; }
  .col-xxl-push-21 {
    left: 87.5%; }
  .col-xxl-push-22 {
    left: 91.6666666667%; }
  .col-xxl-push-23 {
    left: 95.8333333333%; }
  .col-xxl-push-24 {
    left: 100%; }
  .col-xxl-offset-0 {
    margin-left: 0%; }
  .col-xxl-offset-1 {
    margin-left: 4.1666666667%; }
  .col-xxl-offset-2 {
    margin-left: 8.3333333333%; }
  .col-xxl-offset-3 {
    margin-left: 12.5%; }
  .col-xxl-offset-4 {
    margin-left: 16.6666666667%; }
  .col-xxl-offset-5 {
    margin-left: 20.8333333333%; }
  .col-xxl-offset-6 {
    margin-left: 25%; }
  .col-xxl-offset-7 {
    margin-left: 29.1666666667%; }
  .col-xxl-offset-8 {
    margin-left: 33.3333333333%; }
  .col-xxl-offset-9 {
    margin-left: 37.5%; }
  .col-xxl-offset-10 {
    margin-left: 41.6666666667%; }
  .col-xxl-offset-11 {
    margin-left: 45.8333333333%; }
  .col-xxl-offset-12 {
    margin-left: 50%; }
  .col-xxl-offset-13 {
    margin-left: 54.1666666667%; }
  .col-xxl-offset-14 {
    margin-left: 58.3333333333%; }
  .col-xxl-offset-15 {
    margin-left: 62.5%; }
  .col-xxl-offset-16 {
    margin-left: 66.6666666667%; }
  .col-xxl-offset-17 {
    margin-left: 70.8333333333%; }
  .col-xxl-offset-18 {
    margin-left: 75%; }
  .col-xxl-offset-19 {
    margin-left: 79.1666666667%; }
  .col-xxl-offset-20 {
    margin-left: 83.3333333333%; }
  .col-xxl-offset-21 {
    margin-left: 87.5%; }
  .col-xxl-offset-22 {
    margin-left: 91.6666666667%; }
  .col-xxl-offset-23 {
    margin-left: 95.8333333333%; }
  .col-xxl-offset-24 {
    margin-left: 100%; } }
// Global ------  end  ------
</style>



// WEBPACK FOOTER //
// src/App.vue